/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import useFormController from '../hooks/useFormController';
import formControllerState from '../utils/formControllerState';

const FormHelpMessage = (props) => {
  const {
    children,
    id
  } = props;

  const formControl = useFormController();
  const fcs = formControllerState({
    props,
    formControl,
    states: ['disabled']
  });

  const descriptionClasses = classNames('sui-font-regular sui-mt-1 sui-text-xs sui-leading-none sui-text-left', {
    'sui-text-inactive': fcs.disabled,
    'sui-text-subtle': !fcs.disabled
  });

  return (
    <p className={descriptionClasses} id={id}>
      {children}
    </p>
  );
};

FormHelpMessage.displayName = 'FormHelpMessage';

FormHelpMessage.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string
};

FormHelpMessage.defaultProps = {};

export { FormHelpMessage };
